import React from 'react';
import { get } from 'lodash/fp';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { views } from 'enums/menu-enums';
import { setCurrentOpenTabAction, setCurrentCompletedTabAction } from 'store/actions/data';
import { getSearchResultsAction } from 'store/actions/search';
import { FONTS } from 'styles/theme/fonts';
import { COLORS } from 'styles/theme/colors';

export const UnSelectedTabs = ({
  confirmOrders,
  toShipOrders,
  shippedOrders,
  deliveredOrders,
  returnedOrders,
  canceledOrders,
  table,
  currentOpenTab,
  currentCompletedTab,
  currentView,
  activeSearch,
}) => {
  const dispatch = useDispatch();

  const handleTabClick = (tab) => {
    if (table === views.open) {
      dispatch(getSearchResultsAction('', currentOpenTab, currentView));
      dispatch(setCurrentOpenTabAction(tab));
    } else if (table === views.completed) {
      dispatch(getSearchResultsAction('', currentCompletedTab, currentView));
      dispatch(setCurrentCompletedTabAction(tab));
    }
  };
  return (
    <React.Fragment>
      {table === views.open && currentOpenTab !== 'confirm' && (
        <UnSelectedTabs.FirstTab
          isVisible={activeSearch.length > 0}
          isConfirm
          onClick={() => {
            handleTabClick('confirm');
          }}
        >
          {'Confirm'}
          <UnSelectedTabs.Count>{get('metadata.totalCount')(confirmOrders)}</UnSelectedTabs.Count>
        </UnSelectedTabs.FirstTab>
      )}
      {table === views.open && currentOpenTab !== 'toShip' && (
        <UnSelectedTabs.SecondTab
          isVisible={activeSearch.length > 0}
          onClick={() => {
            handleTabClick('toShip');
          }}
        >
          {'To Ship'}
          <UnSelectedTabs.Count>{get('metadata.totalCount')(toShipOrders)}</UnSelectedTabs.Count>
        </UnSelectedTabs.SecondTab>
      )}
      {table === views.open && currentOpenTab !== 'shipped' && (
        <UnSelectedTabs.ThirdTab
          isVisible={activeSearch.length > 0}
          onClick={() => {
            handleTabClick('shipped');
          }}
        >
          {'Shipped'}
          <UnSelectedTabs.Count>{get('metadata.totalCount')(shippedOrders)}</UnSelectedTabs.Count>
        </UnSelectedTabs.ThirdTab>
      )}
      {table === views.open && currentOpenTab !== 'all' && (
        <UnSelectedTabs.FourthTab
          isVisible={activeSearch.length > 0}
          isThird={currentOpenTab === 'shipped'}
          onClick={() => {
            handleTabClick('all');
          }}
        >
          All
        </UnSelectedTabs.FourthTab>
      )}
      {table === views.completed && currentCompletedTab !== 'delivered' && (
        <UnSelectedTabs.FirstTab
          isVisible={activeSearch.length > 0}
          onClick={() => {
            handleTabClick('delivered');
          }}
        >
          {'Delivered'}
          <UnSelectedTabs.Count>{get('metadata.totalCount')(deliveredOrders)}</UnSelectedTabs.Count>
        </UnSelectedTabs.FirstTab>
      )}
      {table === views.completed && currentCompletedTab !== 'returned' && (
        <UnSelectedTabs.SecondTab
          isVisible={activeSearch.length > 0}
          onClick={() => {
            handleTabClick('returned');
          }}
        >
          {'Returned'}
          <UnSelectedTabs.Count>{get('metadata.totalCount')(returnedOrders)}</UnSelectedTabs.Count>
        </UnSelectedTabs.SecondTab>
      )}
      {table === views.completed && currentCompletedTab !== 'canceled' && (
        <UnSelectedTabs.ThirdTab
          isVisible={activeSearch.length > 0}
          onClick={() => {
            handleTabClick('canceled');
          }}
        >
          {'Canceled'}
          <UnSelectedTabs.Count>{get('metadata.totalCount')(canceledOrders)}</UnSelectedTabs.Count>
        </UnSelectedTabs.ThirdTab>
      )}
      {table === views.completed && currentCompletedTab !== 'all' && (
        <UnSelectedTabs.FourthTab
          isVisible={activeSearch.length > 0}
          isThird={currentCompletedTab === 'canceled'}
          onClick={() => {
            handleTabClick('all');
          }}
        >
          All
        </UnSelectedTabs.FourthTab>
      )}
    </React.Fragment>
  );
};

UnSelectedTabs.TabBase = styled.div`
  position: absolute;
  margin-top: -45px;
  font-family: ${FONTS.default};
  letter-spacing: 1px;
  color: ${COLORS.disabledText};
  font-size: 14px;
  width: 190px;
  background-color: ${COLORS.primaryBackground};
  display: flex;
  justify-content: center;
  align-items: center;
  height: 45px;
  border: 1px solid ${COLORS.primaryBorder};
  border-bottom: 0;
  cursor: pointer;
  text-transform: uppercase;

  &:hover {
    border-top: 1px solid ${COLORS.disabledText};
    border-left: 1px solid ${COLORS.disabledText};
    border-right: 2px solid ${COLORS.disabledText};
  }
`;

UnSelectedTabs.FirstTab = styled(UnSelectedTabs.TabBase)`
  margin-left: -1px;
  visibility: ${(props) => (props.isVisible ? 'hidden' : 'visible')};
`;

UnSelectedTabs.SecondTab = styled(UnSelectedTabs.TabBase)`
  margin-left: 188px;
  visibility: ${(props) => (props.isVisible ? 'hidden' : 'visible')};
`;

UnSelectedTabs.ThirdTab = styled(UnSelectedTabs.TabBase)`
  margin-left: 377px;
  visibility: ${(props) => (props.isVisible ? 'hidden' : 'visible')};
`;

UnSelectedTabs.FourthTab = styled(UnSelectedTabs.TabBase)`
  margin-left: ${(props) => (props.isThird ? '565px' : '566px')};
  visibility: ${(props) => (props.isVisible ? 'hidden' : 'visible')};
`;

UnSelectedTabs.Count = styled.div`
  width: 30px;
  height: 30px;
  font-weight: 500;
  font-family: ${FONTS.default};
  font-size: 12px;
  text-align: center;
  color: ${COLORS.disabledText};
  border: 1px solid ${COLORS.primaryBorder};
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 34px;
`;

UnSelectedTabs.propTypes = {
  confirmOrders: PropTypes.shape({
    metadata: PropTypes.shape({
      totalCount: PropTypes.number,
    }),
  }),

  toShipOrders: PropTypes.shape({
    metadata: PropTypes.shape({
      totalCount: PropTypes.number,
    }),
  }),

  shippedOrders: PropTypes.shape({
    metadata: PropTypes.shape({
      totalCount: PropTypes.number,
    }),
  }),
  deliveredOrders: PropTypes.shape({
    metadata: PropTypes.shape({
      totalCount: PropTypes.number,
    }),
  }),
  returnedOrders: PropTypes.shape({
    metadata: PropTypes.shape({
      totalCount: PropTypes.number,
    }),
  }),
  canceledOrders: PropTypes.shape({
    metadata: PropTypes.shape({
      totalCount: PropTypes.number,
    }),
  }),
  currentOpenTab: PropTypes.string,
  currentCompletedTab: PropTypes.string,
  currentView: PropTypes.string,
  table: PropTypes.string,
  activeSearch: PropTypes.string,
};

export default UnSelectedTabs;
